import { z } from 'zod/v4'
import { WorkflowNodeBaseSchema } from '../../../resources/types'

const LiquidTemplateSchema = z.union([
  z.string(),
  z.array(z.record(z.string(), z.unknown())),
  z.record(z.string(), z.unknown()),
])

export const LiquidRenderInputsSchema = z.object({
  template: LiquidTemplateSchema.describe('The Liquid template to render'),
  data: z
    .union([z.string(), z.record(z.string(), z.unknown())])
    .optional()
    .describe('Data to use when rendering the template'),
  isJson: z.boolean().optional().describe('If the data is a json object'),
  outputFormat: z
    .enum(['text', 'json'])
    .optional()
    .default('text')
    .describe(
      'Output format: text returns a rendered string; json parses output and returns response.data',
    ),
  estimateSms: z
    .boolean()
    .optional()
    .describe(
      'When true, include SMS segment estimate for the rendered text in meta.sms',
    ),
})

/** Zod schema only — keep Prisma/runtime code out of this module for client-safe imports. */
export const LiquidRenderCommandSchema = WorkflowNodeBaseSchema.extend({
  service: z.object({
    name: z.literal('skedyul/tools'),
    cmd: z.literal('liquid.render'),
    options: z.object({}).optional(),
  }),
  inputs: LiquidRenderInputsSchema,
})

export type LiquidRenderCommand = z.infer<typeof LiquidRenderCommandSchema>
